module.exports = __webpack_public_path__ + "static/media/economy_manufacturing-min.6815051f.jpg";